"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const layer_1 = __importDefault(require("react-mapbox-gl/lib/layer"));
const layer_events_hoc_1 = __importDefault(require("react-mapbox-gl/lib/layer-events-hoc"));
const Context_1 = require("../map/Context");
/**
 * Replacement for the Layer component from react-mapbox-gl to fix the memory leak
 */
const MapboxLayer = (0, layer_events_hoc_1.default)(layer_1.default);
const unmount = MapboxLayer.prototype.componentWillUnmount;
/**
 *  Overriding the componentWillUnmount to fix the memory leak
 */
/* istanbul ignore next */
MapboxLayer.prototype.componentWillUnmount = function () {
    const map = this.props.map;
    map.off("click", this.id, this.onClick);
    map.off("mouseenter", this.id, this.onMouseEnter);
    map.off("mouseleave", this.id, this.onMouseLeave);
    map.off("mousedown", this.id, this.onMouseDown);
    map.off("touchstart", this.id, this.onTouchStart);
    unmount.call(this);
};
exports.default = (0, Context_1.withMap)(MapboxLayer);
